// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml = require("rescript/lib/js/caml.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var $$String = require("rescript/lib/js/string.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Map = require("rescript/lib/js/belt_Map.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.bs.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.bs.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");
var CustomMapBuilders$SmartcutsMacros = require("../../bs-macros-extension/src/CustomMapBuilders.bs.js");

var t_encode = Decco.intToJson;

var t_decode = Decco.intFromJson;

function toString(htmlTagPathIdentifier) {
  return String(htmlTagPathIdentifier);
}

function toInt(htmlTagPathIdentifier) {
  return htmlTagPathIdentifier;
}

var compare = Caml.caml_int_compare;

function increment(htmlTagPathIdentifier) {
  return htmlTagPathIdentifier + 1 | 0;
}

function fromInt(i) {
  return i;
}

var t_encode$1 = Decco.intToJson;

var t_decode$1 = Decco.intFromJson;

var MapHtmlTagPathIdentifier = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
      t_encode: t_encode$1,
      t_decode: t_decode$1,
      cmp: compare
    });

var t_encode$2 = Decco.intToJson;

var t_decode$2 = Decco.intFromJson;

var compare$1 = Caml_obj.caml_compare;

function make(htmlTagPathIdentifier) {
  return 19968 + htmlTagPathIdentifier | 0;
}

function EncodedHtmlTagPathIdentifier_fromInt(prim) {
  return prim;
}

function EncodedHtmlTagPathIdentifier_asInt(prim) {
  return prim;
}

var t_encode$3 = Decco.intToJson;

var t_decode$3 = Decco.intFromJson;

var MapEncodedHtmlTagPathIdentifier = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
      t_encode: t_encode$3,
      t_decode: t_decode$3,
      cmp: compare$1
    });

function t_encode$4($$this) {
  var len = $$this.length;
  var array = Caml_array.make(0, len);
  $$this.forEach(function (v, index) {
        array[index] = v;
        
      });
  return Json_encode.array((function (prim) {
                return prim;
              }), array);
}

function t_decode$4(json) {
  try {
    var array = Json_decode.array(Json_decode.$$int, json);
    var len = array.length;
    var $$this = new Uint16Array(len);
    array.forEach(function (v, index) {
          $$this[index] = v;
          
        });
    return {
            TAG: /* Ok */0,
            _0: $$this
          };
  }
  catch (raw_message){
    var message = Caml_js_exceptions.internalToOCamlException(raw_message);
    if (message.RE_EXN_ID === Json_decode.DecodeError) {
      return {
              TAG: /* Error */1,
              _0: {
                path: "",
                message: message._1,
                value: json
              }
            };
    }
    throw message;
  }
}

function encodeFromHtmlTagPathIdentifierSequence(sequence) {
  var encodedSequence = new Uint16Array(sequence.length);
  var dictionary = Belt_Array.reduceWithIndex(sequence, Curry._1(MapEncodedHtmlTagPathIdentifier.make, undefined), (function (dictionary, htmlTagPathIdentifier, index) {
          var encoded = 19968 + htmlTagPathIdentifier | 0;
          encodedSequence[index] = Curry._1(EncodedHtmlTagPathIdentifier_asInt, encoded);
          return Belt_Map.set(dictionary, encoded, htmlTagPathIdentifier);
        }));
  return [
          encodedSequence,
          dictionary
        ];
}

function makeText(encodedSequence) {
  var textDecoder = Curry._1(StringUtils$SmartcutsMacros.$$TextDecoder.Utf16.make, undefined);
  return Curry._2(StringUtils$SmartcutsMacros.$$TextDecoder.Utf16.decode, textDecoder, encodedSequence);
}

function fromText(text) {
  var len = text.length;
  var encodedSequence = new Uint16Array(len);
  $$String.iteri((function (index, _char) {
          var codePoint = text.codePointAt(index);
          if (codePoint !== undefined) {
            encodedSequence[index] = codePoint;
            return ;
          } else {
            return Util$SmartcutsMacros.logAndRaiseJsError("Got None from codePointAt(" + (String(index) + ")"));
          }
        }), text);
  return encodedSequence;
}

function decodeToHtmlTagPathIdentifierSequence(encodedSequence, dictionary) {
  var hasEndingDollarChar = encodedSequence.indexOf(36) > -1;
  var encodedSequenceAfterElidingPossibleTrailingDollarChar = hasEndingDollarChar ? encodedSequence.slice(0, encodedSequence.length - 1 | 0) : encodedSequence;
  var len = encodedSequenceAfterElidingPossibleTrailingDollarChar.length;
  var sequence = Caml_array.make(len, -1);
  encodedSequenceAfterElidingPossibleTrailingDollarChar.forEach(function (encoded, index) {
        var arg = Belt_Map.get(dictionary, Curry._1(EncodedHtmlTagPathIdentifier_fromInt, encoded));
        var htmlTagPathIdentifier = (function (param) {
              return OptionUtils$SmartcutsMacros.getExn(param, arg);
            })("Expect to find htmlTagPathIdentifier by encoded " + String(encoded));
        sequence[index] = htmlTagPathIdentifier;
        
      });
  return sequence;
}

function toArray(encodedSequence) {
  var array = [];
  encodedSequence.forEach(function (encodedHtmlTagPathIdentifier, index) {
        array[index] = Curry._1(EncodedHtmlTagPathIdentifier_fromInt, encodedHtmlTagPathIdentifier);
        
      });
  return array;
}

var EncodedHtmlTagPathIdentifierSequence = {
  t_encode: t_encode$4,
  t_decode: t_decode$4,
  encodeFromHtmlTagPathIdentifierSequence: encodeFromHtmlTagPathIdentifierSequence,
  makeText: makeText,
  fromText: fromText,
  decodeToHtmlTagPathIdentifierSequence: decodeToHtmlTagPathIdentifierSequence,
  toArray: toArray
};

function signal_encode(v) {
  return Js_dict.fromArray([
              [
                "wps_enc",
                Decco.stringToJson(v.encodedWebPageSequenceString)
              ],
              [
                "htpi_enc",
                Decco.stringToJson(v.encodedHtmlTagPathIdentifierString)
              ],
              [
                "htpi_pMap",
                Curry._2(MapHtmlTagPathIdentifier.t_encode, t_encode, v.htmlTagPathIdentifierParentMap)
              ]
            ]);
}

function signal_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var encodedWebPageSequenceString = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "wps_enc"), null));
  if (encodedWebPageSequenceString.TAG === /* Ok */0) {
    var encodedHtmlTagPathIdentifierString = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "htpi_enc"), null));
    if (encodedHtmlTagPathIdentifierString.TAG === /* Ok */0) {
      var htmlTagPathIdentifierParentMap = Curry._2(MapHtmlTagPathIdentifier.t_decode, t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "htpi_pMap"), null));
      if (htmlTagPathIdentifierParentMap.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  encodedWebPageSequenceString: encodedWebPageSequenceString._0,
                  encodedHtmlTagPathIdentifierString: encodedHtmlTagPathIdentifierString._0,
                  htmlTagPathIdentifierParentMap: htmlTagPathIdentifierParentMap._0
                }
              };
      }
      var e = htmlTagPathIdentifierParentMap._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".htpi_pMap" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = encodedHtmlTagPathIdentifierString._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".htpi_enc" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = encodedWebPageSequenceString._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".wps_enc" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function output_encode(v) {
  return Js_dict.fromArray([[
                "htpi_enc_seq",
                Decco.arrayToJson(Decco.stringToJson, v.uniqueEncodedHtmlTagPathIdentifierStrings)
              ]]);
}

function output_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var uniqueEncodedHtmlTagPathIdentifierStrings = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict._0, "htpi_enc_seq"), null));
  if (uniqueEncodedHtmlTagPathIdentifierStrings.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              uniqueEncodedHtmlTagPathIdentifierStrings: uniqueEncodedHtmlTagPathIdentifierStrings._0
            }
          };
  }
  var e = uniqueEncodedHtmlTagPathIdentifierStrings._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".htpi_enc_seq" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function nodeFrequencyAndEdgeLength_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var nodeFrequencyEqualsOrGreaterThan = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "nodeFrequencyEqualsOrGreaterThan"), null));
  if (nodeFrequencyEqualsOrGreaterThan.TAG === /* Ok */0) {
    var substringLengthEqualsOrGreaterThan = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "substringLengthEqualsOrGreaterThan"), null));
    if (substringLengthEqualsOrGreaterThan.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                nodeFrequencyEqualsOrGreaterThan: nodeFrequencyEqualsOrGreaterThan._0,
                substringLengthEqualsOrGreaterThan: substringLengthEqualsOrGreaterThan._0
              }
            };
    }
    var e = substringLengthEqualsOrGreaterThan._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".substringLengthEqualsOrGreaterThan" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = nodeFrequencyEqualsOrGreaterThan._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".nodeFrequencyEqualsOrGreaterThan" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function longestCommonSubSequence_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var recordValidationRate = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "recordValidationRate"), null));
  if (recordValidationRate.TAG === /* Ok */0) {
    var patternValidationRate = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "patternValidationRate"), null));
    if (patternValidationRate.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                recordValidationRate: recordValidationRate._0,
                patternValidationRate: patternValidationRate._0
              }
            };
    }
    var e = patternValidationRate._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".patternValidationRate" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = recordValidationRate._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".recordValidationRate" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function longestCommonSubSequence_encode(v) {
  return Js_dict.fromArray([
              [
                "recordValidationRate",
                Decco.floatToJson(v.recordValidationRate)
              ],
              [
                "patternValidationRate",
                Decco.floatToJson(v.patternValidationRate)
              ]
            ]);
}

function nodeFrequencyAndEdgeLength_encode(v) {
  return Js_dict.fromArray([
              [
                "nodeFrequencyEqualsOrGreaterThan",
                Decco.intToJson(v.nodeFrequencyEqualsOrGreaterThan)
              ],
              [
                "substringLengthEqualsOrGreaterThan",
                Decco.intToJson(v.substringLengthEqualsOrGreaterThan)
              ]
            ]);
}

function filter_encode(v) {
  if (typeof v === "number") {
    if (v === /* ByTreeStructure */0) {
      return ["ByTreeStructure"];
    } else {
      return ["ByRepetition"];
    }
  } else if (v.TAG === /* ByNodeFrequencyAndEdgeLength */0) {
    return [
            "ByNodeFrequencyAndEdgeLength",
            nodeFrequencyAndEdgeLength_encode(v._0)
          ];
  } else {
    return [
            "ByLongestCommonSubSequence",
            longestCommonSubSequence_encode(v._0)
          ];
  }
}

function filter_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ByLongestCommonSubSequence" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = longestCommonSubSequence_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ByLongestCommonSubSequence */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "ByNodeFrequencyAndEdgeLength" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = nodeFrequencyAndEdgeLength_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ByNodeFrequencyAndEdgeLength */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "ByRepetition" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ByRepetition */1
                  };
          }
      case "ByTreeStructure" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ByTreeStructure */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringifyFilterName(filter) {
  if (typeof filter === "number") {
    if (filter === /* ByTreeStructure */0) {
      return "ByTreeStructure";
    } else {
      return "ByRepetition";
    }
  } else if (filter.TAG === /* ByNodeFrequencyAndEdgeLength */0) {
    return "ByNodeFrequencyAndEdgeLength";
  } else {
    return "ByLongestCommonSubSequence";
  }
}

function HtmlTagPathIdentifier_toPrintable(prim) {
  return prim;
}

var HtmlTagPathIdentifier = {
  t_encode: t_encode,
  t_decode: t_decode,
  toInt: toInt,
  toString: toString,
  compare: compare,
  init: 0,
  increment: increment,
  fromInt: fromInt,
  toPrintable: HtmlTagPathIdentifier_toPrintable
};

var MapHtmlTagPathIdentifier_KeyCompare = {};

var MapHtmlTagPathIdentifier_t_encode = MapHtmlTagPathIdentifier.t_encode;

var MapHtmlTagPathIdentifier_t_decode = MapHtmlTagPathIdentifier.t_decode;

var MapHtmlTagPathIdentifier_make = MapHtmlTagPathIdentifier.make;

var MapHtmlTagPathIdentifier_fromArray = MapHtmlTagPathIdentifier.fromArray;

var MapHtmlTagPathIdentifier$1 = {
  KeyCompare: MapHtmlTagPathIdentifier_KeyCompare,
  t_encode: MapHtmlTagPathIdentifier_t_encode,
  t_decode: MapHtmlTagPathIdentifier_t_decode,
  make: MapHtmlTagPathIdentifier_make,
  fromArray: MapHtmlTagPathIdentifier_fromArray
};

var EncodedHtmlTagPathIdentifier = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  make: make
};

var MapEncodedHtmlTagPathIdentifier_KeyCompare = {};

var MapEncodedHtmlTagPathIdentifier_t_encode = MapEncodedHtmlTagPathIdentifier.t_encode;

var MapEncodedHtmlTagPathIdentifier_t_decode = MapEncodedHtmlTagPathIdentifier.t_decode;

var MapEncodedHtmlTagPathIdentifier_make = MapEncodedHtmlTagPathIdentifier.make;

var MapEncodedHtmlTagPathIdentifier_fromArray = MapEncodedHtmlTagPathIdentifier.fromArray;

var MapEncodedHtmlTagPathIdentifier$1 = {
  KeyCompare: MapEncodedHtmlTagPathIdentifier_KeyCompare,
  t_encode: MapEncodedHtmlTagPathIdentifier_t_encode,
  t_decode: MapEncodedHtmlTagPathIdentifier_t_decode,
  make: MapEncodedHtmlTagPathIdentifier_make,
  fromArray: MapEncodedHtmlTagPathIdentifier_fromArray
};

exports.HtmlTagPathIdentifier = HtmlTagPathIdentifier;
exports.MapHtmlTagPathIdentifier = MapHtmlTagPathIdentifier$1;
exports.EncodedHtmlTagPathIdentifier = EncodedHtmlTagPathIdentifier;
exports.MapEncodedHtmlTagPathIdentifier = MapEncodedHtmlTagPathIdentifier$1;
exports.EncodedHtmlTagPathIdentifierSequence = EncodedHtmlTagPathIdentifierSequence;
exports.signal_encode = signal_encode;
exports.signal_decode = signal_decode;
exports.output_encode = output_encode;
exports.output_decode = output_decode;
exports.filter_encode = filter_encode;
exports.filter_decode = filter_decode;
exports.nodeFrequencyAndEdgeLength_encode = nodeFrequencyAndEdgeLength_encode;
exports.nodeFrequencyAndEdgeLength_decode = nodeFrequencyAndEdgeLength_decode;
exports.longestCommonSubSequence_encode = longestCommonSubSequence_encode;
exports.longestCommonSubSequence_decode = longestCommonSubSequence_decode;
exports.stringifyFilterName = stringifyFilterName;
/* MapHtmlTagPathIdentifier Not a pure module */
